export function AdminSubscriptionsPage() {
  return <div className="card text-ink-muted">구독 결제 조회 — 다음 단계 구현 예정</div>;
}
